L.Control.LocateMe = L.Control.extend({
    options: {
        position: 'topright',
        zoomLevel: 16, // upon centering on their location, zoom to this level
        markerIcon: {  // use this L.Icon specification to mark their location
            iconUrl: 'leaf-green.png',
            iconSize:     [38, 95], // size of the icon
            iconAnchor:   [22, 94], // point of the icon which will correspond to marker's location
        },
        youAreHere: "You Are Here",  // tooltip for the marker
    },

    initialize: function(options) {
        L.Util.setOptions(this, options);

        this.marker = L.marker([ 0, 0 ], {
            title: this.options.youAreHere,
            icon: L.icon(this.options.markerIcon),
        });
    },

    onAdd: function (map) {
        this.map = map;

        var controlName = 'gin-control-locateme',
            container = L.DomUtil.create('div', controlName + ' leaflet-bar'),
            options = this.options;

        var link = L.DomUtil.create('a', null, container);
        link.innerHTML = '<i class="fa fa-location-arrow"></i>';
        link.href = '#';
        link.title = 'Zoom the map to your location';

        L.DomEvent.on(link, 'click', this._geoGo, this);

		// the usual event-propagation stuff so double-clicking the legend doesn't double-click the map
		L.DomEvent.disableClickPropagation(container);
		L.DomEvent.disableScrollPropagation(container);

        return container;
    },

    _geoGo: function (e) {
        if (! navigator.geolocation) return;
        var control = this;

        navigator.geolocation.getCurrentPosition(function (pos) {
            var latlng = [ pos.coords.latitude, pos.coords.longitude ];
            control.map.setView(latlng, control.options.zoomLevel);
            control.marker.setLatLng(latlng).addTo(control.map);
        }, function (err) {
            console.warn([ 'geolocate failed', err.code, err.message ]);
        }, {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        });
    }
});



// WEBPACK FOOTER //
// ./js/leaflet-control-locateme.js